exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tip[data-v-1eb45196] {\n  color: #909399;\n  margin-bottom: 10px;\n}\n.form[data-v-1eb45196] {\n  max-width: 520px;\n}\n.upload-block[data-v-1eb45196] {\n  display: inline-block;\n}\n.file-path[data-v-1eb45196] {\n  margin-top: 8px;\n  color: #409eff;\n  word-break: break-all;\n}\n", ""]);

// exports
